import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { forkJoin } from 'rxjs';
import { ValidationMsgs } from 'src/app/core/Constants/static';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';
import { ProviderTypeList, SpecialityTypeList } from 'src/app/core/Models/interfaces/responseData';

@Component({
  selector: 'app-prov-details',
  templateUrl: './prov-details.component.html',
  styleUrls: ['./prov-details.component.css']
})
export class ProvDetailsComponent implements OnInit {
  showDetails:boolean=true;
  provDetailsForm!:FormGroup;
  @Input() formGroupName!: string;
  @Input() submitted : boolean=false;
  @Input() isEdit:boolean=false;
  provType:ProviderTypeList[] = [];
  feild_startDate = {
    type: 'datetimepicker',
    inputClassName: ["form-control date-input"],
    selectedDateClassName: ['selectedDate', 'form-control'],
    arrowClassName: ['arrow'],
    dayClassName: ['dd'],
    todayClassName: ['now'],
    monthClassName: ['mtn'],
    monthListClassName: ['monthlist'],
    yearBtnHeadClassName: ['YY'],
    yearListClassName: ['yList'],
    range: true,
    locale: 'en-IN',
    placeholder: 'DD/MM/YYYY',
    options: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    classname: ['form-control'],
  };
  validity_date_v2:InputDatepicker={
    type: 'datepicker_v2',
    name: 'Validity',
    range: true,
    locale: 'en-IN',
    required : true,
    inputClassName:'form-control date-input',
    selectedDateClassName: 'selectedDate',
    arrowClassName: 'arrow',
    dayClassName: 'dd',
    todayClassName: 'now',
    monthClassName: 'mtn',
    datepickerHeaderClass:'', //classes for the active date div
    headerButtonClass:'', // classes for month-year buttons
    yearClassName:'',
    options: {year: 'numeric', month: '2-digit', day: '2-digit'},
    classname: '',
    timer:false,
    disabled:false, // disables the datepicker
    seperator:' to ', // seperator b/w dates
    startDatePlaceHolder:'DD/MM/YYYY',
    dateFormat:'DD/MM/YYYY' ,// dd-mm-yyyy | dd/mm/yyyy
    dateSeperator:'/', // seperator b/w dd,mm,yyyy
  }
  currencyList:any[]=[];
  validationMsg = ValidationMsgs.datePattern;
  EndDateError = ValidationMsgs.EndDateError;
  startDateError = ValidationMsgs.startDateError;
  dummyData= [
    {
      id: 1,
      name: 'ICD',
    },
    {
      id: 2,
      name: 'SDC',
    },
  ];
  specialityList:SpecialityTypeList[]=[]
  constructor(
    private rootFormGroup: FormGroupDirective,
    private provPayerApiService:ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.getMasterLists();
    this.dummyData.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    this.provDetailsForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
 
      
  }
  getMasterLists() {
    forkJoin([
        this.provPayerApiService.getCurrencyList(),
        this.provPayerApiService.getProviderTypeList(),
        this.provPayerApiService.getSpecialityTypeList()

    ]).subscribe({
        next: (responseList) => {
            this.currencyList = responseList[0];
            this.currencyList.sort(function (a, b) {
              var textA = a.currencyDesc.toUpperCase();
              var textB = b.currencyDesc.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.provType=responseList[1];
            this.provType.sort(function (a, b) {
              var textA = a.providerType.toUpperCase();
              var textB = b.providerType.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.specialityList=responseList[2];
            this.specialityList.sort(function (a, b) {
              var textA = a.speciality.toUpperCase();
              var textB = b.speciality.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
        }
    })
}
  selectedValue(event: any, formElem: string) {
    if (!event) {
      this.provDetailsForm.controls[formElem].patchValue(null);
    }  
      this.provDetailsForm.controls[formElem].patchValue(event);
 
  }
  serviceCodeSelect(e:any){
    

  }
}
